module.exports = __webpack_public_path__ + "static/media/bilbo.84b1ea3d.png";